// extracted by mini-css-extract-plugin
module.exports = {"md":"768px","lg":"1280px"};